import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category = "user_action") => {
  const eventTracker = (action, label) => {
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default useAnalyticsEventTracker;
